import cuid from "cuid";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { normalizeAcorisProfile } from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/insurancePlan";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const Profile = ({ project, onNext, onBack, currentStatus, tracer }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("PROFILE", { returnObjects: true });

  const onSubmit = (profile) => {
    return onNext({
      payload: {
        contact: {
          ...get(project, "contact", {}),
          id: get(project, "contact.id") || cuid(),
          fields: {
            ...get(project, "contact.fields", {}),
            profile,
          },
        },
      },
    });
  };

  return (
    <>
      <Navbar project={project} currentStatus={currentStatus} tracer={tracer} />
      <View
        translate={TRANSLATION}
        onNext={onSubmit}
        onBack={onBack}
        initialValue={normalizeAcorisProfile(
          get(project, "contact.fields.profile") ||
            get(project, "fields.profileType", null),
        )}
      />
    </>
  );
};

export default Profile;
